import React from 'react'
import { StyleSheet, Text, View } from "@react-pdf/renderer"
import nanoid from "nanoid"
import { DataField } from "../../../Label"
import ContentBox from "../../../ContentBox"
import ErrorDataText from "../../ErrorDataText"
import {
  builFinancialPendencydDate,
  formatPendenciesInformantBaseName,
  groupPendenciesByInformant,
} from "../../../../../utils/financial_situation_utils"

const styles = StyleSheet.create({
  occurrencesView: {
    padding: 8,
  },
  label: {
    marginTop: 16,
  },
})

const createData = (pending) => {
  const { expiration_date, contract, value, debtor_type, creditor, informant } = pending
  const processed_expiration_date = builFinancialPendencydDate(expiration_date)
  const processed_contract = contract || 'N/A'
  const processed_value = value
  const processed_base = formatPendenciesInformantBaseName(informant)
  return {
    id: nanoid(),
    expiration_date: processed_expiration_date,
    contract: processed_contract,
    value: processed_value,
    debtor_type,
    creditor,
    base: processed_base,
  }
}

const FinancialSituationReport = (props) => {
  const { financial_situation } = props

  const creditScore = financial_situation?.credit_score_data?.quod_score || 'N/A'
  const financialPendencies = financial_situation?.financial_pendings_data?.details?.data?.credit_restrictions_data?.financial_pending
  const occurrences = financialPendencies?.occurrences
  const bases = groupPendenciesByInformant(occurrences)

  try {
    return (
      <View>
        <ContentBox>
          <DataField label="Score de crédito:" value={creditScore} />
        </ContentBox>
        {
          financial_situation?.consumed_serasa && financialPendencies && occurrences && (
            <View>
              <Text style={styles.label}>
                Pendências financeiras:
              </Text>
              <ContentBox>
                <DataField label="Valor total:" value={financialPendencies.total_value} />
                <DataField label="Número de ocorrências:" value={financialPendencies.quantity_occurrences} />
                <DataField label="Serasa:" value={`${bases.serasa.length || 0} ocorrências`} />
                <DataField label="Spc:" value={`${bases.spc.length || 0} ocorrências`} />
                <DataField label="Outros:" value={`${bases.others.length || 0} ocorrências`} />
                {
                  occurrences?.length > 0 && (
                    <View>
                      <DataField label="Ocorrências:" />

                      {occurrences.map((occurrence) => {
                          const data = createData(occurrence)
                          return (
                            <View key={data.id} style={styles.occurrencesView}>
                              <DataField label="Data de vencimento:" value={occurrence.expiration_date} />
                              <DataField label="Contrato:" value={data.contract} />
                              <DataField label="Tipo:" value={data.debtor_type} />
                              <DataField label="Credor:" value={data.creditor} />
                              <DataField label="Valor:" value={data.value} />
                              <DataField label="Base:" value={data.base} />
                            </View>
                          )
                        },
                      )}
                    </View>
                  )
                }
              </ContentBox>
            </View>
          )
        }
      </View>
    )
  } catch (e) {
    return (
      <ErrorDataText
        exception={e}
        contextName="FinancialSituationReport"
        extraData={financial_situation}
      />
    )
  }
}

export default FinancialSituationReport
